export const averageScore = (scores: (number | null)[]): number | null => {
  const values = scores.filter((score): score is number => score !== null)

  if (!values.length) {
    return null
  }

  return Math.round(values.reduce((sum, value) => sum + value, 0) / values.length)
}
